module.exports = __webpack_public_path__ + "img/circle-a.0b676db3.svg";